<template>
    <div class="edit-modal">
        <TitleBaseBox title="修改参数" @confirm="confirmHandle" @close="close">
            <el-form :model="paramsForm" :rules="rules" label-position="left" label-width="80px" ref="paramsForm">
                <el-form-item label="参数名称">
                    <span class="lable-text">{{ row.name }}</span>
                </el-form-item>
                <el-form-item label="参数来源">
                    <span class="lable-text">{{ row.sourceName }}</span>
                </el-form-item>
                <el-form-item label="参数类型">
                    <el-select v-model="paramsForm.type" placeholder="请选择参数类型">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="参数描述" prop="desc">
                    <el-input type="textarea" v-model.trim="paramsForm.desc" oninput="value=value.replace(/[<>]/g,'')"></el-input>
                </el-form-item>
            </el-form>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import { editParams } from "../server";

export default {
    name: "EditParamsModal",
    props: ["data"],
    components: {
        TitleBaseBox
    },
    data() {
        return {
            paramsForm: {
                desc: this.data.rowData.describe,
                type: this.data.rowData.type,
            },
            rules: {
                desc: [{ required: true, message: "请输入参数描述", trigger: "blur" }]
            },
            options: [
                {
                    label: "文本类",
                    value: "string"
                },
                {
                    label: "日期类",
                    value: "datetime"
                },
                {
                    label: "数值类",
                    value: "float"
                },
                {
                    label: "判断类",
                    value: "bool"
                },
            ],
        };
    },
    computed: {
        row() {
            return this.data.rowData;
        },
    },
    methods: {
        confirmHandle() {
            this.$refs.paramsForm.validate(async result => {
                if (result && (this.row.describe !== this.paramsForm.desc || this.row.type !== this.paramsForm.type)) {
                    // 请求修改;
                    await editParams({
                        ...this.row,
                        gameId: this.$store.state.zhiji.gameState.gameId,
                        describe: this.paramsForm.desc,
                        type: this.paramsForm.type,
                    })
                    this.data.confirm()
                    this.close();
                }
            })
        },
        close() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="less" scoped>
.edit-modal{
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .title-base-mask{
        width: 545px;
        .el-form-item {
            margin-bottom: 20px;
        }
        .lable-text {
            line-height: 32px;
        }
        /deep/.el-textarea__inner {
            border: 1px solid #dcdfe6;
        }
    }
}
</style>
